import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { PlanVersionsRepository } from '@efficiently/client-api-plans';
import { GraphQLClient } from '@efficiently/client-core-graphql';

import { DELETE_PLAN_VERSION } from '../queries/delete-plan-version';

@Injectable()
export class PlanVersionsGqlRepository extends PlanVersionsRepository {
	private readonly apollo = inject(Apollo);

	public override deletePlanVersion(planId: string, versionId: string): Observable<boolean> {
		return this.apollo
			.mutate({
				mutation: DELETE_PLAN_VERSION,
				variables: { planId, versionId },
				context: {
					client: GraphQLClient.Core,
				},
			})
			.pipe(map(({ data }) => data.deletePlanVersion));
	}
}
